import { render, staticRenderFns } from "./TeamReachXControl.vue?vue&type=template&id=e92afe12&scoped=true&"
import script from "./TeamReachXControl.vue?vue&type=script&lang=js&"
export * from "./TeamReachXControl.vue?vue&type=script&lang=js&"
import style0 from "./TeamReachXControl.vue?vue&type=style&index=0&id=e92afe12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92afe12",
  null
  
)

export default component.exports